// Vuetify
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { VDateInput } from "vuetify/lib/labs/components.mjs";

const MONTH_NAMES_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];
const MONTH_NAMES_EN = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** Stack format per FormDate: v-date-input selalu panggil dengan 'keyboardDate', jadi kita pakai override dari komponen yang sedang render */
const formatOverrideStack = [];

/** Push format untuk FormDate; mengembalikan index agar bisa di-update saat prop berubah */
export function pushFormatOverride(formatString) {
  formatOverrideStack.push(formatString ?? "DD/MM/YYYY");
  return formatOverrideStack.length - 1;
}

export function popFormatOverride() {
  formatOverrideStack.pop();
}

export function setFormatOverrideAtIndex(index, formatString) {
  if (index >= 0 && index < formatOverrideStack.length) {
    formatOverrideStack[index] = formatString ?? "DD/MM/YYYY";
  }
}

/** Format tanggal tampilan v-date-input. Pakai formatString bila ada, default DD/MM/YYYY */
function formatKeyboardDate(date, formatString, locale) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const month = monthIndex + 1;
  const year = date.getFullYear();
  const d = String(day).padStart(2, "0");
  const m = String(month).padStart(2, "0");

  const isId = typeof locale === "string" && locale.toLowerCase().startsWith("id");
  const monthNames = isId ? MONTH_NAMES_ID : MONTH_NAMES_EN;
  const monthName = monthNames[monthIndex];

  // Saat Vuetify kirim 'keyboardDate', pakai override dari FormDate (format-string) bila ada
  const effectiveFormat =
    formatString === "keyboardDate" && formatOverrideStack.length > 0
      ? formatOverrideStack[formatOverrideStack.length - 1]
      : formatString;

  const isFormatPattern =
    typeof effectiveFormat === "string" &&
    effectiveFormat !== "keyboardDate" &&
    /[dDmMyY]/.test(effectiveFormat);

  // Contoh: "DD MMM YYYY" → "12 Januari 2026", "DD/MM/YY" → "03/02/26"
  if (isFormatPattern) {
    return effectiveFormat
      .replace(/DD|dd/g, d)
      .replace(/D(?!D)|d(?!d)/g, String(day))
      .replace(/MMMM/g, monthName)
      .replace(/MMM/g, monthName)
      .replace(/MM/g, m)
      .replace(/M(?!M)/g, String(month))
      .replace(/YYYY|yyyy/g, String(year))
      .replace(/YY|yy/g, String(year).slice(-2));
  }

  // Default tampilan v-date-input: DD/MM/YYYY
  return `${d}/${m}/${year}`;
}

export const vuetify = createVuetify({
  components: {
    ...components,
    VDateInput,
  },
  directives,
  date: {
    formats: {
      keyboardDate: formatKeyboardDate,
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          secondary: "#6c757d", // Ganti dengan warna text-secondary Bootstrap
        },
      },
      dark: {
        colors: {
          secondary: "#6c757d", // Jika ingin mengganti di tema dark juga
        },
      },
    },
    variations: false, // Matikan variasi warna otomatis agar tidak mempengaruhi swal
  },
});
